import { useContext } from 'react';

import { ErrorHandlerContext, type ErrorHandlerContextProps } from './error-handler.context';

const useErrorHandler = (): ErrorHandlerContextProps => {
  return useContext(ErrorHandlerContext);
};

export default useErrorHandler;
